import { render, staticRenderFns } from "./OrganizationStock.vue?vue&type=template&id=963aeb38&scoped=true&"
import script from "./OrganizationStock.vue?vue&type=script&lang=js&"
export * from "./OrganizationStock.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStock.vue?vue&type=style&index=0&id=963aeb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963aeb38",
  null
  
)

export default component.exports